export default __webpack_public_path__ + "static/media/6.50c2d6b5.jpeg";